import { BASE_COLORS, LAYOUT, media } from "config/theme/constants";
import { Layout } from "antd";
import styled, { css } from "styled-components";

interface HeaderType {
  $isTwoColumnsLayoutHeader: boolean;
}

export const Header = styled(Layout.Header)<HeaderType>`
  line-height: 1.5;
  background: ${BASE_COLORS.selago};

  @media only screen and ${media.md} {
    padding: ${LAYOUT.desktop.paddingVertical}
      ${LAYOUT.desktop.paddingHorizontal};
    height: ${LAYOUT.desktop.headerHeight};
  }

  @media only screen and ${media.xs} {
    padding: 0 20px;
  }

  @media only screen and ${media.md} {
    ${(props) =>
      props?.$isTwoColumnsLayoutHeader &&
      css`
        padding: 0;
      `}
  }
`;
